<template>
  <div>
    <v-container>
      <div class="text-xs-right">
        <v-btn @click="showCreate" outline color="primary">Create</v-btn>
      </div>
      <div>
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr :style="isFirst(props) ? `background-color: #e2ffe2;` : ''">
              <td>
                <v-btn
                  v-if="!isFirst(props)"
                  @click="activeConsent(props.item.id)"
                  small
                  color="primary"
                  >Active</v-btn
                >
              </td>
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.consent_name }}</td>
              <!-- <td>{{ props.item.consent_details }}</td> -->
              <td>{{ props.item.active_date | DateFormat('DD/MM/YYYY HH:mm') }}</td>
              <td>{{ props.item.creata_date | DateFormat('DD/MM/YYYY HH:mm') }}</td>

              <td class="text-xs-right">
                <v-btn @click="showEdit(props.item)" icon> <v-icon>edit</v-icon></v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>
    <div>
      <v-dialog v-model="editDialog" persistent width="1000px">
        <v-card v-if="editDialog">
          <consent-edit
            :edittype="editType"
            :editdata="editData"
            @close="editDialog = false"
            @onsave="onSave"
          ></consent-edit>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'

import { mapGetters } from 'vuex'
import ConsentEdit from './ConsentEdit.vue'
export default {
  components: {
    ConsentEdit
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  data() {
    return {
      editDialog: false,
      editData: '',
      editType: '',
      loading: false,
      items: [],
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: '', value: '', sortable: false },
        { text: 'Version', value: 'id', sortable: false },
        { text: 'Name', value: 'consent_name', sortable: false },
        // { text: 'Details', value: 'consent_details' },
        { text: 'Active date', value: 'active_date', sortable: false },
        { text: 'Create date', value: 'creata_date', sortable: false },
        { text: '', value: '', sortable: false }
      ]
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    isFirst(val) {
      if (val.index === 0 && this.pageNumber === 1 && val.item.active_date) {
        return true
      } else return false
    },
    activeConsent(id) {
      this.$swal
        .fire({
          text: 'Active consent ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            api.generalipdpaActiveConsent(
              {
                pageid: this.selectedBot.pageid,
                id
              },
              (err, response) => {
                this.getData()
              }
            )
          }
        })
    },
    showEdit(item) {
      this.editData = { ...item }
      this.editType = 'edit'
      this.editDialog = true
    },
    showCreate() {
      this.editType = 'create'
      this.editDialog = true
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    onSave() {
      this.editDialog = false
      this.getData()
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,
        limit: this.limit,
        offset: this.offset
      }
      this.$store.dispatch('loading')
      this.loading = true
      api.generalipdpaGetConsent(data, (err, response) => {
        this.items = response.data
        this.$store.dispatch('loading')
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generali/Consent.vue